import { SignupHeader } from "@/components/Page/Header/SignupHeader";

export const ForgotPasswordHeader = SignupHeader;
